import { render, staticRenderFns } from "./DeviceEdit.vue?vue&type=template&id=cb1ebe56&scoped=true&"
import script from "./DeviceEdit.vue?vue&type=script&lang=js&"
export * from "./DeviceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1ebe56",
  null
  
)

export default component.exports